export default {
	de: {
		monthName: {
			0: 'Januar',
			1: 'Februar',
			2: 'März',
			3: 'April',
			4: 'Mai',
			5: 'Juni',
			6: 'Juli',
			7: 'August',
			8: 'September',
			9: 'Oktober',
			10: 'November',
			11: 'Dezember'
		},
		freeAppointments: 'freie Termine'
	},
	pt: {
		monthName: {
			0: 'Janeiro',
			1: 'Fevereiro',
			2: 'Março',
			3: 'Abril',
			4: 'Maio',
			5: 'Junho',
			6: 'Julho',
			7: 'Agosto',
			8: 'Setembro',
			9: 'Outubro',
			10: 'Novembro',
			11: 'Dezembro'
		},
		freeAppointments: 'datas livres'
	}
}
